module.exports = __webpack_public_path__ + "static/media/star_review_selected_ic.0037d4df.svg";